import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth';
import { User } from './classes/user';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  isUserSignedIn = false;
  username?: string;

  constructor(private authService: AuthService) {
    this.isUserSignedIn = this.authService.isUserSignedIn();
  }

  ngOnInit() {
    this.authService.userSignedIn
        .subscribe({
              next: (user: User) => {
                this.username = user.username;
                this.isUserSignedIn = true;
              },
              error: (err: HttpErrorResponse) => {
                console.log(err);
              }
            }
        );
    this.authService.userSignedOut
        .subscribe({
              next: () => {
                this.username = '';
                this.isUserSignedIn = false;
              },
              error: (err: HttpErrorResponse) => {
                console.log(err);
              }
            }
        );
  }
}
